const { Customer } = require('./customer')
const { Invoice } = require('./invoice')
const { CreditMemo } = require('./credit-memo')
const { Payment } = require('./payment')
const { Account } = require('./account')
const { Purchase } = require('./purchase')
const { Changes } = require('./changes')
const { Query } = require('./query')
const { Batch } = require('./batch')
const { Report } = require('./report')
const { JournalEntry } = require('./journal-entry')

class EntitiesApi {
  constructor (quickbooks) {
    this.payment = new Payment(quickbooks)
    this.purchase = new Purchase(quickbooks)
    this.changes = new Changes(quickbooks)
    this.query = new Query(quickbooks)
    this.account = new Account(quickbooks, this.query)
    this.invoice = new Invoice(quickbooks, this.query)
    this.creditMemo = new CreditMemo(quickbooks, this.query)
    this.batch = new Batch(quickbooks)
    this.report = new Report(quickbooks)
    this.customer = new Customer(quickbooks, this.query)
    this.journalEntry = new JournalEntry(quickbooks, this.query)
  }
}

module.exports = {
  EntitiesApi
}
